import { purchaseBillUpdateApi } from "../../api/purchaseBill/purchaseBillUpdateApi"

type PayloadShape = Parameters<typeof purchaseBillUpdateApi>[0]

export async function purchaseBillUpdateService(payload: PayloadShape, token: string) {
	return await purchaseBillUpdateApi(payload, token)
}
